import {Tabs} from "antd";
import {useTranslation} from "react-i18next";
import "./css/style.css"
import AccountVerify_3 from "./component/accountVerify";
import VerificationHistory_3 from "./component/verificationHistory";
import {useState} from "react";

export default function AccountVerificationV2_3(props) {
    const { t } = useTranslation();
    const { deepLinkTab, deepLinkId } = props;
    const [currentTab, setCurrentTab] = useState(deepLinkTab === 'uploadHistory' ? 'uploadHistory' : 'accountVerification');

    const tabItems = [
        {
            key: "accountVerification",
            label: t("accountVerification.accountVerification"),
            children: (
                <AccountVerify_3
                    {...props}
                />
            )
        },
        {
            key: "uploadHistory",
            label: t("accountVerification.uploadHistory"),
            children: (
                <VerificationHistory_3 {...props} currentTab={currentTab} deepLinkId={deepLinkId}/>
            ),
        },
    ]

    return (
        <div id={"accountVerificationV2"}>
            <Tabs
                activeKey={currentTab}
                items={tabItems}
                className={"tabColour"}
                onChange={(key) => setCurrentTab(key)}
            />
        </div>
    )
}